module.exports = __webpack_public_path__ + "static/media/focus.641510db.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程GLR增程式厢式车/focus.png
// module id = 706
// module chunks = 0